import React from "react";
import ConveyorScene from "../Home/ConveyorScene";

function ScreenSizeFallback() {
  return (
    <div className="relative h-screen overflow-hidden">
      <div className="w-full m-auto">
        <ConveyorScene />
      </div>

      <div className="absolute bottom-2 left-36 bg-[#3B2E09] w-[248px] h-[688.552px] rotate-[39.237deg] rounded-[50%] blur-[150px]" />
      <div className="absolute top-2 right-52 bg-[#2C4146] w-[248px] h-[688.552px] rotate-[39.237deg] rounded-[50%] blur-[150px]" />
      <div
        className="absolute inset-0 z-10 flex items-center justify-center m-auto"
        role="dialog"
        aria-modal="true"
        aria-labelledby="screen-size-title"
        aria-describedby="screen-size-desc"
      >
        <div className="w-full max-w-xl p-10 text-center ">
          <h1
            id="screen-size-title"
            className="text-2xl md:text-3xl font-semibold font-Gilroy bg-clip-text text-transparent bg-gradient-to-r from-[#EAEAEA] to-[#848484] tracking-wide"
          >
            This page isn’t available on small screens
          </h1>

          <p
            id="screen-size-desc"
            className="mt-4 text-sm leading-relaxed text-gray-200 md:text-base"
          >
            The full Products experience is designed for larger screens (desktop
            or tablet in landscape). Please open this site on a larger device to
            view the page correctly.
          </p>

          <p className="mt-4 text-xs text-gray-400">
            Tip: Try using a desktop or rotate your tablet to landscape for the
            best experience.
          </p>
        </div>
      </div>
    </div>
  );
}

export default ScreenSizeFallback;
